import { forwardRef, ComponentProps, useRef, useImperativeHandle } from 'react'

import joinClassNames from 'utilities/joinClassNames'

import styles from './styles.module.scss'
import fieldStyle from '../field.module.scss'

const Root = ({ className, ...props }: ComponentProps<'div'>) => {
  return <div {...props} className={joinClassNames(styles.root, className)} />
}

interface InputProps extends ComponentProps<'input'> {
  appearance?: 'error' | 'neutral'
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ appearance, className, ...props }, ref) => {
    const inputRef = useRef<HTMLInputElement>(null)

    useImperativeHandle(ref, () => inputRef.current, [inputRef])

    return (
      <input
        type="radio"
        {...props}
        ref={(element) => {
          inputRef.current = element

          if (typeof ref === 'function') {
            ref(element)
          } else if (ref) ref.current = element
        }}
        className={joinClassNames(
          appearance && fieldStyle[appearance],
          className,
        )}
      />
    )
  },
)

Input.displayName = 'Input'

const Item = ({ className, ...props }: ComponentProps<'div'>) => {
  return <div {...props} className={joinClassNames(styles.item, className)} />
}

const Label = ({ className, children }: ComponentProps<'label'>) => {
  return (
    <label className={joinClassNames(styles.label, className)}>
      {children}
    </label>
  )
}

const RadioButton = {
  Root,
  Item,
  Label,
  Input,
}

export default RadioButton
